
/* styles */
require("!!../../../../node_modules/_extract-text-webpack-plugin@1.0.1@extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../node_modules/_vue-loader@11.3.4@vue-loader/lib/style-compiler/index?{\"id\":\"data-v-87e3eb4a\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/_vue-loader@11.3.4@vue-loader/lib/selector?type=styles&index=0!./card_choose.vue")

var Component = require("!../../../../node_modules/_vue-loader@11.3.4@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/_vue-loader@11.3.4@vue-loader/lib/selector?type=script&index=0!./card_choose.vue"),
  /* template */
  require("!!../../../../node_modules/_vue-loader@11.3.4@vue-loader/lib/template-compiler/index?{\"id\":\"data-v-87e3eb4a\"}!../../../../node_modules/_vue-loader@11.3.4@vue-loader/lib/selector?type=template&index=0!./card_choose.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/module/main/views/card_choose.vue
// module id = 194
// module chunks = 1